// surgeons.ts
// Service functions for interacting with surgeon-related APIs.
// Provides search, subscribe, unsubscribe, and retrieval operations for surgeons.

import { tokenAxios } from "@/utils/axios";
import { SurgeonSearch, SurgeonSearchArgs, SurgeonSubscribed, SurgeonSubscribedArgs, SurgeonSubscribeArgs, SurgeonUnsubscribeArgs } from "@/types/surgeons";

/**
 * Searches for surgeons based on search parameters.
 * @param params - Search parameters
 * @returns Array of matching surgeons
 */
export const searchSurgeons = async (params: SurgeonSearchArgs) => {
  const { data } = await tokenAxios().get<SurgeonSearch[]>("/api/surgeons/search", {
    params,
  });
  return data;
};

/**
 * Retrieves the list of subscribed surgeons for a user/practice.
 * @param params - Parameters for retrieving subscribed surgeons
 * @returns Array of subscribed surgeons
 */
export const getSubscribedSurgeons = async (params: SurgeonSubscribedArgs) => {
  const { data } = await tokenAxios().get<SurgeonSubscribed[]>("/api/surgeons/subscribed", {
    params,
  });
  return data;
};

/**
 * Subscribes to a new surgeon.
 * @param params - Parameters for subscribing to a surgeon
 * @returns Updated array of subscribed surgeons
 */
export const postSubscribedSurgeon = async (params: SurgeonSubscribeArgs) => {
  const { data } = await tokenAxios().post<SurgeonSubscribed[]>("/api/surgeons/subscribed", params);
  return data;
};

/**
 * Unsubscribes from a surgeon.
 * @param params - Parameters for unsubscribing from a surgeon
 * @returns Confirmation string or status
 */
export const deleteSubscribedSurgeon = async (params: SurgeonUnsubscribeArgs) => {
  const { data } = await tokenAxios().delete<string>("/api/surgeons/subscribed", {
    params,
  });
  return data;
};
